interface Experiment<ParamValues> {
    name: string;
    paramName: string;
    values: ParamValues;
}
export type ExperimentMap = Record<string, ExperimentData>;
export type ExperimentData = Record<string, unknown>;

const HomepageBannerCTAValues = {
    control: 'search',
    base: 'city_browse',
};

export const HomepageBannerCTAExperiment: Experiment<
    typeof HomepageBannerCTAValues
> = {
    name: 'banner_cta_opens_search_screen',
    paramName: 'banner_cta_destination',
    values: HomepageBannerCTAValues,
};

export enum SearchMapSmokeTestExperimentValues {
    control = 'control',
    variantA = 'variantA',
}

export const SearchMapSmokeTestExperiment: Experiment<
    typeof SearchMapSmokeTestExperimentValues
> = {
    name: 'search_view_map_smoke_test',
    paramName: 'smoke_map_type',
    values: SearchMapSmokeTestExperimentValues,
};

/**
 * Leave the names of the enums/configs/etc static to keep imports from
 * needing to change as we iterate.
 *
 * Update the values to represent the new focus/paramname/goal of the test.
 * At the moment these correlate to the card map exported from DiscoverEventCard.
 */
export enum SearchCardFullClickExperimentValues {
    control = 'control',
    fullClick = 'fullClick',
}

export const SearchCardFullClickExperiment: Experiment<
    typeof SearchCardFullClickExperimentValues
> = {
    name: 'search_event_card_full_click_client',
    paramName: 'search_card_type',
    values: SearchCardFullClickExperimentValues,
};
